"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleChoiceContent = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = require("../../../../Button");
const ControlSeparator_1 = require("../../../ControlSeparator");
const MultipleChoiceContent_styles_1 = require("./MultipleChoiceContent.styles");
const MultipleChoiceItem_1 = require("../MultipleChoiceItem/MultipleChoiceItem");
const constants_1 = require("../../helpers/constants");
const StackView_1 = require("../../../../StackView");
exports.MultipleChoiceContent = react_1.default.memo(function MultipleChoiceContent({ onSelectAll, onClearAll, data, canClearAll, columnSize, canSelectAll, onToggleItem, isSelected, texts }) {
    const columnCount = (0, react_1.useMemo)(() => Math.ceil(data.length / columnSize), [columnSize, data.length]);
    const uiTexts = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, constants_1.DEFAULT_TEXTS), texts)), [texts]);
    return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column },
        react_1.default.createElement(MultipleChoiceContent_styles_1.StyledMultipleChoiceContentContent, { columnCount: columnCount }, data.map((item, idx) => {
            const column = Math.floor(idx / columnSize) + 1;
            const row = columnSize + idx + 1 - columnSize * column;
            return (react_1.default.createElement(MultipleChoiceItem_1.MultipleChoiceItem, { key: `${idx + 1}`, data: item, column: column, row: row, index: idx, onToggle: onToggleItem, selected: isSelected(idx) }));
        })),
        react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.m, align: StackView_1.STACK_ALIGN.center },
            react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.text, disabled: !canSelectAll, onClick: onSelectAll, "data-selector-id": "multiplechoice-select-all-control" }, uiTexts.selectAll),
            react_1.default.createElement(ControlSeparator_1.ControlSeparator, null),
            react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.text, disabled: !canClearAll, onClick: onClearAll, "data-selector-id": "multiplechoice-clear-all-control" }, uiTexts.clearAll))));
});
//# sourceMappingURL=MultipleChoiceContent.js.map